import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import WebpImage from '@r1-frontend/ui-react/components/WebpImage';
import { useMatchMedia } from '@r1-frontend/shared/hooks/useMatchMedia';

import MobileStores from '~/src/features/agent/components/MobileStores';

import * as ST from './styled';

const imgStaticPath = '/static/images/service/agent';

const AgentHeader = (): JSX.Element => {
    const isMobile = useMatchMedia(`(max-width: ${wideBreakpoints.mobile})`);

    const currentImg = isMobile ? 'iPhone_Bottom_mobile' : 'iPhone_Bottom';

    return (
        <ST.HeaderWrapper>
            <ST.Container>
                <ST.ContentBlock>
                    <ST.PageTitle id='page-title'>Ваш Дом.ру в&nbsp;ваших руках</ST.PageTitle>
                    <ST.Desc>Всё управление тарифом в&nbsp;одном приложении</ST.Desc>
                    <MobileStores position={'up'}/>
                </ST.ContentBlock>
                <ST.ImageBlock>
                    <ST.ImageBlockInnerWrapper>
                        <WebpImage urlWebp={`${imgStaticPath}/${currentImg}.webp`}>
                            <ST.MainImage
                                src={`${imgStaticPath}/${currentImg}.png`}
                                alt='Изображение мобильного телефона с приложением Дом.ру'
                            />
                        </WebpImage>
                        <ST.SMobileStoreQrLabel isLazy={false} data-test='header-qr'/>
                    </ST.ImageBlockInnerWrapper>
                </ST.ImageBlock>
            </ST.Container>
        </ST.HeaderWrapper>
    );
};

export default AgentHeader;
